import React from "react";
import styled from "styled-components";
import { useCongress } from "../../congress/hooks";
import LayoutContainer from "./Container";
import Button from "../Button";
import { MD_BREAKPOINT, SM_BREAKPOINT } from "../../breakpoints";
import { useRequest } from "../../fetchboi/hooks";
import { Icon } from "rsuite";
import SpeakersGrid from "./SpeakersGrid";
import { motion } from "framer-motion";

export default function Header() {
  const { congress, generateLink } = useCongress();
  const [speakers, loading] = useRequest({ url: "/speakers" });
  return (
    <Container
      backgroundImage={congress.BannerURL}
      fallbackColor={congress.SecondaryColor}
    >
      <LayoutContainer>
        <Content>
          <LeftContainer>
            <LogoContainer>
              <Logo src={congress.LogoURL} />
            </LogoContainer>
            <ButtonContainer
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.9 }}
            >
              <Button
                rounded
                external={congress.LandingButtonType === "External"}
                color={congress.PrimaryColor}
                to={congress.LandingButtonURL}
                target="_blank"
              >
                <span>{congress.LandingButtonText}</span>
                <Icon icon="external-link" />
              </Button>
            </ButtonContainer>
          </LeftContainer>
          <HeaderContainer>
            {!loading && (
              <SpeakersGrid
                speakers={speakers}
                congress={congress}
                generateLink={generateLink}
              />
            )}
          </HeaderContainer>
        </Content>
      </LayoutContainer>
    </Container>
  );
}

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  padding: 2rem 0;
  padding-top: 0;
  justify-content: center;
  align-items: center;
  @media screen and (max-width: ${MD_BREAKPOINT}em) {
    align-items: flex-end;
    padding-top: 1rem;
  }
`;

const Container = styled.div`
  width: 100%;
  padding-bottom: 7rem;
  padding-top: 3rem;
  display: flex;
  background-image: url("${(props) => props.backgroundImage}");
  background-color: ${(props) => props.fallbackColor};
  background-position: center bottom;
  background-size: cover;

  @media screen and (max-width: ${SM_BREAKPOINT}em) {
    padding: 2rem 0;
  }
`;

const Content = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;

  @media screen and (max-width: ${MD_BREAKPOINT}em) {
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
`;

const LogoContainer = styled.div`
  background: #fff;
  padding: 2rem 7rem;
  width: 100%;
  max-width: 35rem;
  max-height: 26rem;
  border-radius: 1.2rem;
  display: inline-block;
  text-align: center;
  box-shadow: 0 6px 12px rgba(141, 141, 141, 0.36);

  @media screen and (max-width: ${MD_BREAKPOINT}em) {
    margin-bottom: 1rem;
  }
  @media screen and (max-width: ${SM_BREAKPOINT}em) {
    padding: 2rem 2rem;
  }
`;

const Logo = styled.img`
  width: 100%;
  height: 14rem;
  max-height: 18rem;
  object-fit: contain;
`;

const ButtonContainer = styled(motion.div)`
  a span {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
  }
`;

const LeftContainer = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;

  @media screen and (max-width: 930px) {
    width: 100%;
    gap: 0.5rem;
  }

  @media screen and (max-width: ${SM_BREAKPOINT}em) {
    width: 100%;
  }
`;
